var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.1386 14 0 10.8614 0 7C0 3.1386 3.1386 0 7 0C10.8614 0 14 3.1386 14 7C14 10.8614 10.8614 14 7 14ZM7 0.976744C3.67907 0.976744 0.976744 3.67907 0.976744 7C0.976744 10.3209 3.67907 13.0233 7 13.0233C10.3209 13.0233 13.0233 10.3209 13.0233 7C13.0233 3.67907 10.3209 0.976744 7 0.976744ZM5.15341 9.33107C5.02969 9.33107 4.90597 9.28549 4.80829 9.18781C4.61946 8.99897 4.61946 8.68642 4.80829 8.49758L6.30597 6.9999L4.80829 5.50223C4.61946 5.31339 4.61946 5.00083 4.80829 4.812C4.99713 4.62316 5.30969 4.62316 5.49853 4.812L6.9962 6.30967L8.49387 4.812C8.68271 4.62316 8.99527 4.62316 9.18411 4.812C9.37294 5.00083 9.37294 5.31339 9.18411 5.50223L7.68643 6.9999L9.18411 8.49758C9.37294 8.68642 9.37294 8.99897 9.18411 9.18781C9.08643 9.28549 8.96271 9.33107 8.83899 9.33107C8.71527 9.33107 8.59155 9.28549 8.49387 9.18781L6.9962 7.69014L5.49853 9.18781C5.40736 9.28549 5.27713 9.33107 5.15341 9.33107Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.fb049f481265828d9255857e798c343d.svg";
export { ForwardRef as ReactComponent };